import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function OfferBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'HRS'
  }, {
    value: minutes,
    label: 'MIN'
  }, {
    value: seconds,
    label: 'SEC'
  }];
  return <div className="sticky top-0 z-50 flex h-11 w-full items-center justify-center gap-2 border-b border-ember/30 bg-card px-4 text-white" data-id="element-181" data-mp="t2dzkyo200tv">
      <p className="text-[10px] font-extrabold uppercase tracking-[0.1em] text-ember sm:text-xs" data-id="element-182" data-mp="fahcj918sh4c">
        ⚡ Launch offer ends in:
      </p>
      <p className="flex items-baseline gap-1 text-[11px] font-extrabold tabular-nums sm:text-sm" role="timer" aria-live="off" data-id="element-183" data-mp="k3snnmd37k22">
        {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-184" data-mp="a9tkck1a1u8j" data-mpi={index}>
            {index > 0 && <span aria-hidden="true" className="text-ember" data-id="element-185" data-mp="3sikp7lna7ow4">
                :
              </span>}
            <span data-id="element-186" data-mp="1dkplio8vjsq">
              {unit.value}
              <span className="ml-0.5 text-[8px] font-bold uppercase tracking-[0.1em] text-neutral-400 sm:text-[9px]" data-id="element-187" data-mp="qyk31vztnbup">
                {unit.label}
              </span>
            </span>
          </React.Fragment>)}
      </p>
    </div>;
}